import React from 'react';
import { GridDetailsPanelColumnDef } from 'utils/components/GridDetailsPanel/gridDetailsPanelColumnDef';
import { GridDetailsPanelField } from 'utils/components/GridDetailsPanel/GridDetailsPanelField';
import { ResponsiveColumns } from '../ResponsiveColumns/ResponsiveColumns';
import { GridDetailColDef } from 'utils/components/GridDetailsPanel/GridDetailsPanel';

export interface GridDetailsPanelColumnProps<
    TColumnId extends string,
    TEntity extends Partial<Record<TColumnId, unknown>>,
> {
    colDefs: GridDetailColDef<TEntity>[];
    entity: TEntity;
    column: GridDetailsPanelColumnDef<TColumnId>;
}

export function GridDetailsPanelColumn<
    TColumnId extends string,
    TEntity extends Partial<Record<TColumnId, unknown>>,
>(props: GridDetailsPanelColumnProps<TColumnId, TEntity>) {
    const { column, entity, colDefs } = props;
    return (
        <ResponsiveColumns.Column fullWidth={column.fullWidth}>
            {column.controls.map((c, i) =>
                c.type === 'title' ? (
                    <div className="title" key={'fld-' + i}>
                        {c.text}
                    </div>
                ) : (
                    <GridDetailsPanelField
                        colDefs={colDefs}
                        control={c}
                        entity={entity}
                        key={'fld-' + i}
                    />
                )
            )}
        </ResponsiveColumns.Column>
    );
}
